import { ReactElement } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { authUser } from '../utils/userService'

export const ProtectedRoutes = (): ReactElement => {
  return !authUser() ? <Outlet /> : <Navigate to="/" />
}
